import { useLayoutEffect } from 'react'

const HideFileUploadButton = () => {
  useLayoutEffect(() => {
    document.querySelector('.str-chat__fileupload-wrapper')?.remove()
  })
  return null
}

export default HideFileUploadButton
